var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9895 14.4375C11.9895 11.736 8.9775 9.54 6.276 9.54C3.5745 9.54 0.5625 11.736 0.5625 14.4375M6.276 7.092C7.14187 7.092 7.97227 6.74804 8.58453 6.13578C9.19679 5.52352 9.54075 4.69312 9.54075 3.82725C9.54075 2.96138 9.19679 2.13098 8.58453 1.51872C7.97227 0.906464 7.14187 0.5625 6.276 0.5625C5.41013 0.5625 4.57973 0.906464 3.96747 1.51872C3.35521 2.13098 3.01125 2.96138 3.01125 3.82725C3.01125 4.69312 3.35521 5.52352 3.96747 6.13578C4.57973 6.74804 5.41013 7.092 6.276 7.092Z",
    stroke: "#3F3F3F",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f3dcd71e65ac2bb82a43e955a477da2f.svg";
export { ForwardRef as ReactComponent };